var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlyph081Creditcard = function SvgGlyph081Creditcard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 337 500"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M290.5 130.15h-244A46.55 46.55 0 0 0 0 176.65v159.7a46.55 46.55 0 0 0 46.5 46.5h244a46.55 46.55 0 0 0 46.5-46.5v-159.7a46.55 46.55 0 0 0-46.5-46.5m-244 17h244a29.54 29.54 0 0 1 29.5 29.5V197H17v-20.35a29.54 29.54 0 0 1 29.5-29.5m244 218.7h-244a29.54 29.54 0 0 1-29.5-29.5V231h303v105.35a29.54 29.54 0 0 1-29.5 29.5M45.92 324.63h55.84v17H45.92Zm189.1-17h55.84v34H235Z"
  })));
};
export default SvgGlyph081Creditcard;